// Registry of per-state article clusters. Each entry tells <ArticlePage />
// where the article data lives, the URL prefix and the human-readable state
// name used in copy / breadcrumbs / SEO. Adding a new state's cluster is
// purely additive: drop a data file under src/data/ and register it here.

import { CA_GUIDES, getArticle as getCAArticle, ARTICLE_DISCLAIMER as CA_DISCLAIMER, ARTICLE_CTA as CA_CTA } from "../data/california_guides";
import { NY_GUIDES, getNYArticle, NY_ARTICLE_DISCLAIMER, NY_ARTICLE_CTA } from "../data/newyork_guides";
import { TX_GUIDES, getTXArticle, TX_ARTICLE_DISCLAIMER, TX_ARTICLE_CTA } from "../data/texas_guides";
import { FL_GUIDES, getFLArticle, FL_ARTICLE_DISCLAIMER, FL_ARTICLE_CTA } from "../data/florida_guides";

export const STATE_GUIDES = {
  california: {
    stateName: "California",
    basePath: "/california-car-bill-of-sale",
    guides: CA_GUIDES,
    getArticle: getCAArticle,
    disclaimer: CA_DISCLAIMER,
    cta: CA_CTA,
    processTitle: "From scan to signed in 3 minutes — for California sellers and buyers",
    processLede: "Every step happens online. Snap your ID, decode your VIN, sign with your finger or mouse, and the signed PDF lands in both inboxes.",
  },
  "new-york": {
    stateName: "New York",
    basePath: "/new-york-car-bill-of-sale",
    guides: NY_GUIDES,
    getArticle: getNYArticle,
    disclaimer: NY_ARTICLE_DISCLAIMER,
    cta: NY_ARTICLE_CTA,
    processTitle: "From scan to signed in 3 minutes — for New York sellers and buyers",
    processLede: "Every step happens online. Snap your ID, fill the MV-912 bill of sale, sign with your finger or mouse, and the signed PDF lands in both inboxes.",
  },
  texas: {
    stateName: "Texas",
    basePath: "/texas-car-bill-of-sale",
    guides: TX_GUIDES,
    getArticle: getTXArticle,
    disclaimer: TX_ARTICLE_DISCLAIMER,
    cta: TX_ARTICLE_CTA,
    processTitle: "From scan to signed in 3 minutes — for Texas sellers and buyers",
    processLede: "Every step happens online. Snap your ID, fill the bill of sale, sign with your finger or mouse, and the signed PDF lands in both inboxes — ready for Form 130-U at the county tax office.",
  },
  florida: {
    stateName: "Florida",
    basePath: "/florida-car-bill-of-sale",
    guides: FL_GUIDES,
    getArticle: getFLArticle,
    disclaimer: FL_ARTICLE_DISCLAIMER,
    cta: FL_ARTICLE_CTA,
    processTitle: "From scan to signed in 3 minutes — for Florida sellers and buyers",
    processLede: "Every step happens online. Snap your ID, fill the bill of sale, sign with your finger or mouse, and the signed PDF lands in both inboxes — ready for Form HSMV 82040 at the county tax collector and the Notice of Sale (HSMV 82050) online.",
  },
};

export function getStateGuides(stateSlug) {
  return STATE_GUIDES[stateSlug] || null;
}
